import { FunctionComponent } from 'react';

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import { Tooltip, Typography } from '@mui/material';
import { Stack } from '@mui/system';

import useAuth from '../../hooks/useAuth';
import { AuthUser } from '../../ports/auth';

type EcopilotUserBadgeProps = {
    user: AuthUser;
};

const EcopilotUserBadge: FunctionComponent<EcopilotUserBadgeProps> = ({ user }) => {
    if (user.isAdmin()) {
        return (
            <Tooltip title="You are identified as a power user for this service">
                <AdminPanelSettingsIcon color="warning" />
            </Tooltip>
        );
    }

    return null;
};

export const HeaderTitle: FunctionComponent = () => {
    const { user } = useAuth();

    return (
        <Stack direction="row" alignItems="center" pl={6}>
            <Typography>Ecopilot</Typography>
            {user && <EcopilotUserBadge user={user} />}
        </Stack>
    );
};
